import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = [<>
    Sacas <strong data-id="element-160">"ladrillos" del horno</strong> cada vez que intentas hacer pan
    y ya no sabes qué estás haciendo mal — y lo mismo te pasa con pasteles y
    postres 😩
  </>, <>
    El pan te queda <strong data-id="element-161">duro, gomoso o se desmorona como arena</strong>, los
    pasteles salen secos y los postres nunca tienen la textura que deberían 😤
  </>, <>
    <strong data-id="element-162">Gastas dinero en harinas caras</strong> que terminan en la basura, y
    cada intento fallido te quita las ganas de volver a intentarlo 💸
  </>, <>
    Sientes que la dieta sin gluten te obliga a{' '}
    <strong data-id="element-163">resignarte para siempre al pan de cartón</strong>, a los postres
    insípidos y a decir que no en cada reunión 😞
  </>, <>
    Pagas <strong data-id="element-164">precios absurdos por productos industriales</strong> sin
    gluten que saben a nada y no duran ni un día frescos 😠
  </>];
export function PainPointsSection() {
  return <section className="py-5 md:py-10 px-4 bg-brand-creamAlt" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-terracotta text-white text-center py-5 px-6 rounded-xl mb-8 shadow-lg" data-id="element-167">
          <h2 className="text-2xl md:text-3xl font-heading font-bold uppercase tracking-wide" data-id="element-168">
            ESTO ES PARA TI SI...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-169">
          {painPoints.map((content, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="flex items-center gap-4 bg-white p-5 md:p-6 rounded-xl shadow-sm border-l-[6px] border-brand-terracotta" data-id="element-170">
              <XCircle className="w-7 h-7 text-white fill-brand-red flex-shrink-0" data-id="element-171" />
              <p className="text-lg text-brand-brownLight leading-relaxed [&_strong]:text-brand-brown" data-id="element-172">
                {content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}